import React, { useEffect, useState } from "react";
import TopServiceHeader from "../components/TopSection/TopServiceHeader";
import DetailsSection from "../components/InfoBox/DetailsSection";
import GallerySection from "../components/Gallery/GallerySection";
import SelectedServiceSection from "../components/Services/SelectedServiceSection";
import PaymentStatus from "../components/Reserved/PaymentStatus";
import Layout from "../components/Layout/Layout";
import DescriptionSection from "../components/Description/DescriptionSection";
import styles from "./Service-Details.module.css";
import { BusinessService } from "../services/business-service";
import { useLocation } from "react-router-dom";

const ServiceDetails: React.FC = () => {
  const location = useLocation();
  const { reservation } = location.state || {};

  const [partnerGallery, setPartnerGallery] = useState<string[]>([]);

  useEffect(() => {
    const fetchPartner = async () => {
      if (reservation?.partnerId) {
        const businessService = new BusinessService();
        const partner = await businessService.getPartner(reservation.partnerId);
        if (partner?.gallery) {
          setPartnerGallery(partner.gallery);
        }
      }
    };

    fetchPartner();
  }, [reservation?.partnerId]);

  return (
    <div className={styles.container}>
      <div className={styles.scrollableContent}>
        <TopServiceHeader />
        <DetailsSection />
        <GallerySection gallery={partnerGallery} />
        <SelectedServiceSection />
        <DescriptionSection />
      </div>

      <PaymentStatus />
    </div>
  );
};

export default ServiceDetails;
